import React from 'react';
import { FaCalendarAlt, FaEdit, FaEye } from 'react-icons/fa';

const TimetableHeader = ({ mode, setMode, selectedClassId, setError }) => {
  return (
    <div className="flex items-center justify-between mb-6">
      <h1 className="text-2xl font-bold text-gray-800 flex items-center">
        <FaCalendarAlt className="text-blue-600 mr-2" />
        Timetable Management
      </h1>
      <div className="flex gap-2">
        <button
          className={`px-4 py-2 rounded-lg font-medium transition-all ${mode === 'add' 
            ? 'bg-blue-600 text-white hover:bg-blue-700 shadow' 
            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
          onClick={() => setMode('add')}
        >
          <FaEdit className="inline mr-2" /> Add/Edit
        </button>
        <button
          className={`px-4 py-2 rounded-lg font-medium transition-all ${mode === 'view' 
            ? 'bg-blue-600 text-white hover:bg-blue-700 shadow' 
            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
          onClick={() => {
            if (!selectedClassId) {
              setError('Please select a class first', 'error');
              return;
            }
            setMode('view');
          }}
        >
          <FaEye className="inline mr-2" /> View
        </button>
      </div>
    </div>
  );
};

export default TimetableHeader;